
  import classNames from 'classnames'
  import React from 'react'
  import styles from '../NamedIcon.module.scss'
  import IconHoC from '../NamedIconHoC'
  import type { NamedIconPropsType } from '../types'
  
  export const LocationPinIcon: React.FC<NamedIconPropsType> = ({className, rtl = false, outline = false, ...props  }) => {
    let Foreground,
      Background = null
    if (!rtl) {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M51.5 59.7664C64.2043 58.057 74 47.1725 74 34C74 19.6406 62.3594 8 48 8C33.6406 8 22 19.6406 22 34C22 47.1725 31.7957 58.057 44.5 59.7664V84.5C44.5 86.433 46.067 88 48 88C49.933 88 51.5 86.433 51.5 84.5V59.7664ZM29 34C29 23.5066 37.5066 15 48 15C58.4934 15 67 23.5066 67 34C67 44.4934 58.4934 53 48 53C37.5066 53 29 44.4934 29 34Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M70.5 34C70.5 46.4264 60.4264 56.5 48 56.5C35.5736 56.5 25.5 46.4264 25.5 34C25.5 21.5736 35.5736 11.5 48 11.5C60.4264 11.5 70.5 21.5736 70.5 34Z" fill="#F2F2F3"/>
</svg>

    } else {
      Foreground = <svg className={styles['pintxo-icon__foreground']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M51.5 59.7664C64.2043 58.057 74 47.1725 74 34C74 19.6406 62.3594 8 48 8C33.6406 8 22 19.6406 22 34C22 47.1725 31.7957 58.057 44.5 59.7664V84.5C44.5 86.433 46.067 88 48 88C49.933 88 51.5 86.433 51.5 84.5V59.7664ZM29 34C29 23.5066 37.5066 15 48 15C58.4934 15 67 23.5066 67 34C67 44.4934 58.4934 53 48 53C37.5066 53 29 44.4934 29 34Z" fill="#161617"/>
</svg>

      Background = !outline && <svg className={styles['pintxo-icon__background']}width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M70.5 34C70.5 46.4264 60.4264 56.5 48 56.5C35.5736 56.5 25.5 46.4264 25.5 34C25.5 21.5736 35.5736 11.5 48 11.5C60.4264 11.5 70.5 21.5736 70.5 34Z" fill="#F2F2F3"/>
</svg>

    }
    return <IconHoC rtl={rtl} outline={outline} className={classNames(styles['pintxo-icon'], className)} {...props}>
      {Foreground && Foreground}
      {Background && Background}
    </IconHoC>
  }
  
